import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import './index.scss';

const UserPlaceholder = () => {
    return (
        <>
            <div className="user-placeholder d-flex align-items-center justify-content-center rounded-circle w-100 h-100">
                <FontAwesomeIcon icon={faUser} />
            </div>
        </>
    );
}

export default UserPlaceholder;